import { ReferralNavigationCard } from '@features/wellbeing-referrals/components/ReferralNavigationCard'
import { SimpleGrid, Stack, Text, Title } from '@mantine/core'
import { IconClipboardList, IconInbox, IconPlus, IconSettings } from '@tabler/icons-react'
import { createFileRoute } from '@tanstack/react-router'
import { useMePermissionsSuspense } from '@features/rbac/queries'
import { useQuery } from '@tanstack/react-query'
import { getAwaitingActionWellbeingReferralCounts, getUnassignedWellbeingReferralCount } from '@features/wellbeing-referrals/api'
import { useStaffOverrideStore } from '@stores/useStaffOverrideStore'

export const Route = createFileRoute('/_layout/referrals/wellbeing/')({
    component: RouteComponent,
})

function RouteComponent() {
    const { data: permissions } = useMePermissionsSuspense()
    const assignedPermissions = ['wellbeing-referrals.action', 'wellbeing-referrals:me.action', 'wellbeing-referrals:careers.action', 'wellbeing-referrals:counselling.action', 'wellbeing-referrals:learning-support.action', 'wellbeing-referrals:student-services.action']
    const canSeeAssigned = assignedPermissions.some(permission => permissions.includes(permission))
    const canManage = permissions.includes('wellbeing-referrals.manage')
    const staffOverride = useStaffOverrideStore(state => state.override?.trim() || null)
    const { data: awaiting } = useQuery({ queryKey: ['wellbeing-referrals', 'assigned', 'awaiting-action-count', staffOverride], queryFn: getAwaitingActionWellbeingReferralCounts, enabled: canSeeAssigned, staleTime: 30_000 })
    const { data: unassigned } = useQuery({ queryKey: ['wellbeing-referrals', 'unassigned-count', staffOverride], queryFn: getUnassignedWellbeingReferralCount, enabled: canManage, staleTime: 30_000 })
    return (
        <Stack p="lg" gap="lg" maw={1000} mx="auto" w="100%">
            <Stack gap={3}>
                <Title order={2}>Health &amp; Wellbeing referrals</Title>
            </Stack>
            <SimpleGrid cols={{ base: 1, sm: 2 }}>
                <ReferralNavigationCard title="Create referral" description="Submit a new Health & Wellbeing referral." icon={IconPlus} to="/referrals/wellbeing/create" />
                <ReferralNavigationCard title="My referrals" description="View referrals you have created." icon={IconClipboardList} to="/referrals/wellbeing/my" />
                {canManage && <ReferralNavigationCard title="Manage referrals" description="Review and manage all Health & Wellbeing referrals." icon={IconSettings} to="/referrals/wellbeing/manage" indicator={unassigned?.count} />}
                {canSeeAssigned && <ReferralNavigationCard title="Referrals assigned to me" description="View referrals currently assigned to you." icon={IconInbox} to="/referrals/wellbeing/assigned" indicator={awaiting?.count} />}
            </SimpleGrid>
        </Stack>
    )
}
